/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import leftArrow from '../images/left-arrow.svg';
import rightArrow from '../images/right-arrow.svg';

export const SectionSoftware = styled.div`
  background: ${({ background }) =>
    background.includes('--') ? `var(${background})` : background};

  .section-software--container {
    max-width: 1270px;
    padding: 98px 40px 107px;
    margin: 0 auto;

    .section-software--header-container {
      max-width: 784px;
      text-align: center;
      margin: 0 auto;

      .section-software--title {
        text-align: center;
        color: ${({ isDarkBackground }) => (isDarkBackground ? 'var(--white)' : 'var(--darkest)')};
      }

      .section-software--description {
        text-align: center;
      }
    }

    .section-software--content-container {
      display: flex;
      margin-top: 30px;

      .section-software--navigation-content {
        position: relative;
        margin: 20px 40px 20px 0;
        width: 263px;

        .section-software--navigation-item {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          cursor: pointer;
          position: relative;

          ${({ isDarkBackground }) =>
            isDarkBackground
              ? `
          .in-page-features-link {
            color: var(--white);
          }
          `
              : ''};

          .section-software--navigation-item-title {
            font-weight: var(--font-weight-500);
            line-height: var(--line-height-150);
            white-space: nowrap;
          }

          &:hover {
            opacity: 0.8;
          }

          &.selected-item {
            .section-software--navigation-item-title {
              color: var(--titan-blue-3);
            }

            opacity: 1;
          }
        }

        .section-software--navigation-cta {
          position: absolute;
          right: 0;
          bottom: 0;
          height: 62px;
          box-shadow: none;
        }

        .section-software--navigation-item-arrow {
          position: absolute;
          right: -55px;
          top: 6px;
          transition: top 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
          z-index: 100;
        }
      }

      .section-software--content-content {
        flex: 1;
        overflow: hidden;

        .slick-track {
          display: flex;

          .slick-slide {
            height: auto;

            & > div {
              height: 100%;
            }
          }
        }

        .slick-prev,
        .slick-next {
          bottom: 0;
          left: auto;
          border-radius: 50%;
          top: auto;
          width: 45px;
          height: 45px;
          z-index: 1;
          box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);

          &:before {
            width: 45px;
            height: 45px;
            color: transparent;
          }
        }

        .slick-prev {
          right: 60px;
          background-image: url('${leftArrow}') !important;
          background-color: var(--white);
          background-repeat: no-repeat !important;
          background-size: 10px !important;
          background-position: center !important;
        }

        .slick-next {
          right: 5px;
          background-image: url('${rightArrow}') !important;
          background-color: var(--white);
          background-repeat: no-repeat !important;
          background-size: 10px !important;
          background-position-x: 18px !important;
          background-position-y: center !important;
        }
      }

      .section-software--main-content {
        height: 100%;
        display: flex !important;
        align-items: center;
        flex-direction: column;
        background: ${({ mainContentBg, isDarkBackground }) =>
          mainContentBg ||
          `linear-gradient(90deg, ${
            isDarkBackground ? '#22252A' : 'rgba(255,255,255,1)'
          } 0%, rgba(255,255,255,0) 100%)`};
        background-position-x: 1px;
        padding: 40px 45px 84px;

        .section-software--description-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          margin-top: 20px;

          .section-software--description-content-container {
            margin: 10px auto 0;
            padding: 0;
            text-align: center;

            h2 {
              font-size: var(--font-size-p-md);
              color: ${({ isDarkBackground }) =>
                isDarkBackground ? 'var(--white)' : 'var(--darkest)'};
            }

            .font-p {
              font-size: var(--font-size-mobile-p);
              color: ${({ isDarkBackground }) =>
                isDarkBackground ? 'var(--white)' : 'var(--darkest)'};
              margin: 0;
            }

            a {
              color: var(--titan-blue-3);
            }
          }
        }

        .section-software--image-content,
        .section-software--video-content {
          width: 100%;
          max-height: 400px;
          display: flex;
          align-items: center;
          justify-content: center;
          div {
            max-height: 400px;
          }

          .gatsby-image-wrapper {
            width: inherit;
            picture {
              img {
                margin: 0 auto;
                max-height: 100%;
              }
            }
          }

          img {
            width: auto;
            height: auto;
            max-width: min(681px, 100%);
            max-height: inherit;
          }

          .video-main-container .video-preview-container .video-preview-video {
            max-height: 400px;
          }
        }
      }
    }
  }

  @media (max-width: 1120px) {
    .section-software--container {
      .section-software--content-container {
        .section-software--navigation-content {
          width: fit-content;
        }

        .section-software--main-content {
          .section-software--description-content {
            .section-software--description-content-container {
              font-size: var(--font-size-16);
            }
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
    .section-software--container {
      padding: 65px 20px;

      .section-software--header-container {
        .section-software--title {
          font-size: var(--font-size-35);
          line-height: var(--line-height-120);
        }

        .section-software--description {
          font-size: var(--font-size-18);
          line-height: 28px;
          margin-top: 22px;
          padding: 0 10px;
        }
      }
    }
  }

  @media (max-width: 575px) {
    .section-software--container {
      padding: 67px 20px 75px;

      .section-software--header-container {
        .section-software--title {
          font-size: var(--font-size-28);
          line-height: 36px;
        }

        .section-software--description {
          font-size: var(--font-size-20);
          line-height: 28px;
          padding: 0;
        }
      }

      .section-software--description-content-container {
        padding-top: 30px;
      }
    }
  }
`;
